export type NumberRange = {
  min?: number;
  max?: number;
};

export function isEmptyRange({ min, max }: NumberRange): boolean {
  return min === undefined && max === undefined;
}

export function orderedRange({ min, max }: NumberRange): NumberRange {
  const isInverted = min !== undefined && max !== undefined && min > max;
  return isInverted ? { min: max, max: min } : { min, max };
}

export function matchesRange(
  value: number | undefined,
  range: NumberRange,
): boolean {
  if (isEmptyRange(range)) return true;
  if (value === undefined) return false;
  const isAboveMin = range.min === undefined || value >= range.min;
  const isBelowMax = range.max === undefined || value <= range.max;
  return isAboveMin && isBelowMax;
}
